import { Route, useLocation, Routes, Navigate } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';
import LoadingPage from './components/global/LoadingPage';
import Login from './pages/auth/Login';
import ProtectedRoute from './components/global/ProtectedRoute';
import Home from './pages/Home';
import Layout from './layout/Layout';
import Profile from './pages/profile/Profile';

// Import modular routes
import usersRoutes from './routes/usersRoutes';
import rolesRoutes from './routes/rolesRoutes';
import schoolsRoutes from './routes/schoolsRoutes';
import academicYearsRoutes from './routes/academicYearsRoutes';
import academicTermsRoutes from './routes/academicTermsRoutes';
import levelsRoutes from './routes/levelsRoutes';
import departmentsRoutes from './routes/departmentsRoutes';
import jobTitlesRoutes from './routes/jobTitlesRoutes';
import orgStructureItemsRoutes from './routes/orgStructureItemsRoutes';
import employeesRoutes from './routes/employeesRoutes';
import teachersRoutes from './routes/teachersRoutes';
import orgStructureAssignmentsRoutes from './routes/orgStructureAssignmentsRoutes';
import classesRoutes from './routes/classesRoutes';
import guardiansRoutes from './routes/guardiansRoutes';
import studentsRoutes from './routes/studentsRoutes';
import studentEnrollmentsRoutes from './routes/studentEnrollmentsRoutes';

const RoutesPath = () => {
    const ScrollToTop = () => {
        const { pathname } = useLocation();
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);
        return null;
    };

    return (
        <>
            <ScrollToTop />
            <Suspense fallback={<LoadingPage />}>
                <Routes>
                    {/* Auth Routes */}
                    <Route path="/login" element={<Login />} />

                    {/* 403 Forbidden Page */}
                    <Route path="/forbidden" element={<Forbidden />} />

                    {/* Protected Routes */}
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }>

                        {/* Home - Redirect to dashboard */}
                        <Route index element={<Navigate replace to="dashboard" />} />

                        {/* Dashboard - Available for all authenticated users */}
                        <Route path="dashboard" element={<Home />} />

                        {/* Profile - Available for all authenticated users */}
                        <Route path="profile" element={<Profile />} />

                        {/* Schools Module */}
                        {schoolsRoutes}

                        {/* Academic Years Module */}
                        {academicYearsRoutes}

                        {/* Academic Terms Module */}
                        {academicTermsRoutes}

                        {/* Levels Module */}
                        {levelsRoutes}

                        {/* Departments Module */}
                        {departmentsRoutes}

                        {/* Job Titles Module */}
                        {jobTitlesRoutes}

                        {/* Org Structure Items Module */}
                        {orgStructureItemsRoutes}

                        {/* Employees Module */}
                        {employeesRoutes}

                        {/* Teachers Module */}
                        {teachersRoutes}

                        {/* Org Structure Assignments Module */}
                        {orgStructureAssignmentsRoutes}

                        {/* Classes Module */}
                        {classesRoutes}

                        {/* Guardians Module */}
                        {guardiansRoutes}

                        {/* Students Module */}
                        {studentsRoutes}

                        {/* Student Enrollments Module */}
                        {studentEnrollmentsRoutes}

                        {/* Users Module */}
                        {usersRoutes}

                        {/* Roles Module */}
                        {rolesRoutes}

                    </Route>
                    {/* End Protected Routes */}

                    {/* 404 Not Found */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </>
    );
};

export default RoutesPath;
